import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { API_URL } from '../config';

const Comments = () => {
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  // Fetch comments from API (using the correct URL)
  useEffect(() => {
    fetchComments();
  }, []);

  const fetchComments = async () => {
    try {
      const response = await fetch('https://dsdspl.com/api/panchyat-api/public/api/comments/index');
      const data = await response.json();

      // Sort comments by date in descending order to get the latest ones
      const sortedComments = data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      // Display only the latest 3 comments
      setComments(sortedComments.slice(0, 3));
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  // Handle form inputs
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit the new comment
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://dsdspl.com/api/panchyat-api/public/api/comments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        // Show success message
        Swal.fire({
          title: "Thank you for your response!",
          text: "Comment added successfully.",
          icon: "success",
        });

        // Fetch and show the latest comments
        fetchComments();

        // Reset form
        setFormData({
          name: '',
          email: '',
          message: '',
        });
      } else {
        // In case of any error, log it and show the error
        console.error('Error:', result);
        Swal.fire({
          title: "Error",
          text: "There was an issue adding your comment. Please try again.",
          icon: "error",
        });
      }
    } catch (error) {
      // If there's an error during the request, show an alert
      console.error('Error submitting comment:', error);
      Swal.fire({
        title: "Error",
        text: "There was an issue submitting your comment. Please try again later.",
        icon: "error",
      });
    }
  };

  return (
    <>
      <div className="bg-light rounded p-4">
        <h4 className="mb-4">Comments</h4>

        {/* Display latest 3 comments */}
        {comments.length > 0 ? (
          comments.map((comment, index) => (
            <div key={index} className="p-4 bg-white rounded mb-4">
              <div className="row g-4">
                <div className="col-12">
                  <div className="d-flex justify-content-between">
                    <h5>{comment.name}</h5>
                  </div>
                  <small className="text-body d-block mb-3">
                    <i className="fas fa-calendar-alt me-1"></i> {new Date(comment.created_at).toLocaleDateString()}
                  </small>
                  <p className="mb-0">{comment.message}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No comments available yet.</p>
        )}
      </div>

      {/* Comment Form */}
      <div className="bg-light rounded p-4 my-4">
        <h4 className="mb-4">Leave A Comment</h4>
        <form onSubmit={handleSubmit}>
          <div className="row g-4">
            <div className="col-lg-6">
              <input
                type="text"
                className="form-control py-3"
                placeholder="Full Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-lg-6">
              <input
                type="email"
                className="form-control py-3"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12">
              <textarea
                className="form-control"
                cols="30"
                rows="7"
                placeholder="Write Your Comment Here"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div className="col-12">
              <button className="form-control btn btn-primary py-3" type="submit">
                Submit Now
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Comments;
